module.exports = __webpack_public_path__ + "media/images/icon__betPick--pick@3x-d53c2662e799fa7003eeee0413c9eb78.png";